import React, { useState } from "react";
import getTranslationData from "../../../TranslationUtility/TranslationUtility";
import ModalComponent from "../../Giftcards/Modal";
import { useCheckoutContext } from "../context/CheckoutContext";

const RedemptionConsent = ({ showRedemptionFee, isChecked, onChange }) => {
  const translation = getTranslationData();
  const { productReducer } = useCheckoutContext();
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  if (!showRedemptionFee) return null;

  return (
    <>
      <div className="redemption-fee-container mt-3 mb-4">
        <input
          type="checkbox"
          className="redemption-checkbox"
          checked={isChecked}
          onChange={(e) => onChange(e.target.checked)}
          aria-label="Redemption fee acknowledgement"
        />
        <p className="redemption-text">
          {translation?.redemption_fee_text}
          <span className="know-more" onClick={() => setIsSheetOpen(true)}>
            {translation?.know_more_text}
          </span>
        </p>
      </div>
      <ModalComponent
        productDetails={productReducer}
        show={isSheetOpen}
        modalClass={"termsModal"}
        handleClose={() => setIsSheetOpen(false)}
        RedemHeading={"Redemption Fee T&C"}
        RedemContent={translation?.redemption_fee_content || ""}
      />
    </>
  );
};

export default RedemptionConsent;
